__turbopack_context__.v({
  "blockquote": "LegacyInlineFormatting-module__HR9nlG__blockquote",
  "center": "LegacyInlineFormatting-module__HR9nlG__center",
  "underline": "LegacyInlineFormatting-module__HR9nlG__underline",
});
